import { render, staticRenderFns } from "./NflSportsBook.vue?vue&type=template&id=3f2d4c7d&scoped=true"
import script from "./NflSportsBook.vue?vue&type=script&lang=js"
export * from "./NflSportsBook.vue?vue&type=script&lang=js"
import style0 from "./NflSportsBook.vue?vue&type=style&index=0&id=3f2d4c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d4c7d",
  null
  
)

export default component.exports